// import { PlayerHomeActions } from './../../../redux/player-home/player-home-actions';
// import { PlayerInfo } from './../../../data/mygolf.data';
// import { PlayerService } from './../../../providers/player-service/player-service';
import { ImageData, ImageService } from './../../../../providers/image-service/image-service';
import { Component } from '@angular/core';
import {
  AlertController,
  LoadingController,
  ModalController,
  NavController,
  NavParams,
  Platform,
} from '@ionic/angular';
import { Observable } from 'rxjs';
/**
 * Created by Ashok on 21-06-2016.
 */
@Component({
  templateUrl: "image-zoom.page.html",
  selector: 'image-zoom',
  styleUrls: ['./image-zoom.page.scss']
})
export class ImageZoomPage {
  // player: PlayerInfo;
  // player$: Observable<PlayerInfo>;
  playerPhoto$: Observable<string>;
  friend: boolean;
  image: string;

  originalImage: string;
  // images: any = [];
  images: Array<string> = [];

  description: string;
  descTopDown: string = 'down'
  constructor(private nav: NavController,
    // private playerHomeActions: PlayerHomeActions,
    private navParams: NavParams,
    private loadingCtl: LoadingController,
    private alertCtl: AlertController,
    private imageService: ImageService,
    // private playerService: PlayerService,
    private platform: Platform,
    private modalCtl: ModalController
  ) {
    // this.image = navParams.get("image");
    this.originalImage = navParams.get("image");
    // if(typeof this.originalImage !== 'undefined')


    if (this.originalImage && this.originalImage.length > 0 && this.originalImage.includes(','))
      this.images = this.originalImage.split(',');
    else if (this.originalImage && this.originalImage.length > 0 && !this.originalImage.includes(','))
      this.images.push(this.originalImage)
    else this.images.push(this.originalImage);

    this.description = navParams.get("description");
    this.descTopDown = navParams.get("descTopDown");

  }

  ionViewDidEnter() {
  }

  close() {
    this.modalCtl.dismiss();
  }
}
